import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Play, ExternalLink } from 'lucide-react';
import { getReleases, getImageUrl, formatDateET } from '../utils/api';
import './ReleasesPage.css';

const ReleasesPage = () => {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReleases = async () => {
      try {
        const data = await getReleases();
        setReleases(data);
      } catch (error) {
        console.error('Failed to fetch releases', error);
      } finally {
        setLoading(false);
      }
    };
    fetchReleases();
  }, []);

  return (
    <div className="releases-page" data-testid="releases-page">
      {/* Hero */}
      <section className="releases-hero">
        <div className="releases-hero-bg"></div>
        <div className="releases-hero-overlay"></div>
        <div className="container releases-hero-content">
          <h1>Releases</h1>
          <p>The complete AMR catalogue — from main stage anthems to underground gems.</p>
        </div>
      </section>

      {/* Releases Grid */}
      <section className="releases-listing">
        <div className="container">
          {loading ? (
            <div className="loading-container"><div className="loader"></div></div>
          ) : releases.length === 0 ? (
            <p className="no-results">No releases yet.</p>
          ) : (
            <div className="releases-page-grid">
              {releases.map((release) => (
                <Link
                  to={`/releases/${release.slug || release.id}`}
                  key={release.id}
                  className="release-page-card"
                  data-testid={`release-card-${release.id}`}
                >
                  <div className="release-page-artwork">
                    <img
                      src={getImageUrl(release.artwork)}
                      alt={release.title}
                      loading="lazy"
                    />
                    <div className="release-page-hover">
                      <Play size={36} fill="currentColor" />
                    </div>
                  </div>
                  <div className="release-page-info">
                    <h3>{release.title}</h3>
                    <p className="release-page-artist">{release.artist_name}</p>
                    <div className="release-page-meta">
                      <span className="release-page-genre">{release.genre}</span>
                      {release.release_date && (
                        <span className="release-page-date">
                          {formatDateET(release.release_date, { year: 'numeric', month: 'short' })}
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ReleasesPage;
